const cancellationStatuses = ['cancelledOnTime', 'cancelledLate'];

function isFutureAttendanceDate(date, now = Date.now()) {
  const today = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(new Date(now));
  return Boolean(date && date > today);
}

function isFinalizedAttendance(record) {
  if (!record) return false;
  const details = record.lessonDetails || {};
  if (details.lessonStatus === 'cancelled') return false;
  if (details.attendanceStatus && details.attendanceStatus !== 'checked') return false;
  const students = record.students || [];
  return students.length > 0 && students.every(student => (
    (typeof student.isPresent === 'boolean' && student.participationStatus !== 'scheduled' && !cancellationStatuses.includes(student.participationStatus)) ||
    (details.attendanceStatus === 'checked' && cancellationStatuses.includes(student.participationStatus))
  ));
}

function assertAttendanceDate(record, existing, now) {
  const details = record.lessonDetails || {};
  const previousDetails = (existing && existing.lessonDetails) || {};
  // Dedicated cancellation guards retain their existing conflict responses.
  if (details.lessonStatus === 'cancelled' || (existing && existing.lessonDetails && existing.lessonDetails.lessonStatus === 'cancelled')) return;
  if (!isFutureAttendanceDate(details.date || previousDetails.date, now)) return;
  const previousStudents = (existing && existing.students) || [];
  const decisionsChanged = (record.students || []).some(student => {
    if (cancellationStatuses.includes(student.participationStatus) || student.participationStatus === 'scheduled') return false;
    if (typeof student.isPresent !== 'boolean') return false;
    const previous = previousStudents.find(item => item.id === student.id);
    return !previous || previous.isPresent !== student.isPresent || previous.participationStatus !== student.participationStatus;
  });
  if (record.recordAttendance === true || decisionsChanged ||
      (isFinalizedAttendance(record) && (!isFinalizedAttendance(existing) || details.date !== previousDetails.date))) {
    const error = new Error('FUTURE_ATTENDANCE_NOT_ALLOWED');
    error.statusCode = 400;
    throw error;
  }
}

// recordAttendance is a command flag, never persisted. The server owns the clock.
function applyAttendanceTimestamp(record, existing, now = new Date().toISOString()) {
  assertAttendanceDate(record, existing, now);
  const { recordAttendance, ...next } = record;
  const lessonDetails = { ...(next.lessonDetails || {}) };
  delete lessonDetails.attendanceCheckedAt;
  const previousTime = existing && existing.lessonDetails && existing.lessonDetails.attendanceCheckedAt;
  if (previousTime) lessonDetails.attendanceCheckedAt = previousTime;
  if (isFinalizedAttendance(next) && (recordAttendance === true || !isFinalizedAttendance(existing))) {
    lessonDetails.attendanceCheckedAt = now;
  }
  return { ...next, lessonDetails };
}

module.exports = { isFinalizedAttendance, applyAttendanceTimestamp, isFutureAttendanceDate };
